import { Heading } from "../../components";
import UserProfile from "../../components/UserProfile";
import React from "react";

const degrees = [
  {
    startDate: (
      <>
        SEP
        <br />
        2024
      </>
    ),
    endDate: (
      <>
        JUL
        <br />
        2028
      </>
    ),
    degreeTitle: "Bachelor HBO-ICT ",
    universityName: "Fontys university of applied sciences",
    greetingText: "After receiving my degree at Scalda, I decided to continue my studies to deepen my knowledge. I chose Fontys because of its diverse range of opportunities, including an option to cybersecurity, an area I’m eager to explore further.",
    tags: ["C#", "SQL", "React"],
    imgSrc: "images/img_qp9l717r_400x400.png"


  },
  {
    startDate: (
      <>
        SEP
        <br />
        2021
      </>
    ),
    endDate: (
      <>
        JUL
        <br />
        2024
      </>
    ),
    degreeTitle: "Software Developer",
    universityName: "Scalda",
    greetingText: "Started here directly after highschool i already knew i wanted to do something with IT and had some epxerience. Worked on many projects over the year wich you can see at the \"projects\" section. Also i was able to finish the study in 3 years instead of 4.",
    tags: ["SQL", "Java", "Hibernate", "Struts2", "React"],
    imgSrc: "images/img_logo_klein.png"
  },
]

export default function Study() {
  return (
    <section id="study" className="relative container-xs flex justify-center min-h-screen">
      <div className="mt-[74px] self-stretch">
        <div className="flex items-center justify-center md:flex-col">
          <div className="md:hidden absolute -left-[50%] w-[50%] bg-orange-400 h-[50%]"/>
          <div id="pacman" className="md:hidden absolute left-0 overflow-hidden bg-orange-400 rounded-r-full pl-12 h-[50%] w-[25%] flex flex-col gap-12 items-center justify-center">
            <div className="h-20 w-20 rounded-full bg-black-900" />
            <div className="h-20 w-20 rounded-full bg-black-900" />
          </div>
          <div className="container-xs flex flex-col items-start md:px-5">
            <Heading size="heading2xl" as="h2" className="text-[96px] font-bold text-white-a700 md:text-[48px]">
              <span className="text-white-a700">Study</span>
              <span className="text-orange-a200">.</span>
            </Heading>
            <div className="ml-[480px] flex flex-col gap-[78px] self-stretch md:ml-0">
              {
                degrees.map((degree => (
                  <UserProfile startDate={degree.startDate} endDate={degree.endDate}
                    greetingText={degree.greetingText} title={degree.degreeTitle} universityName={degree.universityName}
                    tags={degree.tags} imgSrc={degree.imgSrc} />
                )))
              }
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
